import React, { useState } from 'react';
import axios from 'axios';
import { App, Button, Card, Input, Space, Typography } from 'antd';
import { BackendAlertTest, triggerBackendAlertTest } from './api';

export const BackendAlertTests: React.FC = () => {
  const { message } = App.useApp();
  const [running, setRunning] = useState<BackendAlertTest | null>(null);
  const [status, setStatus] = useState<number | null>(500);
  const validStatus = status !== null && Number.isInteger(status) && status >= 400 && status <= 599;

  const run = async (kind: BackendAlertTest) => {
    setRunning(kind);
    try {
      await triggerBackendAlertTest(kind);
      message.success(typeof kind === 'number'
        ? `Backend returned the expected HTTP ${kind} and generated ${kind < 500 ? 'Warn' : 'Error'} telemetry.`
        : 'Backend emitted a zerolog Error.');
    } catch (error) {
      if (!axios.isCancel(error)) message.error(error instanceof Error ? error.message : 'Backend test failed.');
    } finally { setRunning(null); }
  };
  return <Card title="Backend telemetry tests">
    <Space direction="vertical" size="middle">
      <Typography.Paragraph>
        Generate test events on the backend for the current Admin session. These actions intentionally create error telemetry.
        Choose an integer status from 400–599: 4xx emits Warn and 5xx emits Error. Allow time for export, then check Grafana or Logfire; a successful trigger does not confirm delivery or an alert notification.
      </Typography.Paragraph>
      <Space wrap>
        <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>HTTP status
          <Input type="number" aria-label="Test HTTP status" min={400} max={599} step={1} value={status ?? ''}
            style={{ width: 100 }} status={validStatus ? undefined : 'error'} disabled={running !== null}
            onChange={event => setStatus(event.target.value === '' ? null : Number(event.target.value))} />
        </label>
        <Button loading={typeof running === 'number'} disabled={running !== null || !validStatus}
          onClick={() => { if (validStatus && status !== null) void run(status); }}>Trigger HTTP error</Button>
        <Button loading={running === 'log-error'} disabled={running !== null} onClick={() => void run('log-error')}>Emit Error log</Button>
      </Space>
    </Space>
  </Card>;
};
